module.exports = __webpack_public_path__ + "media/gateway/paybadgesbarulu-ce5a7c7f.jpg";